export enum ThemeEnum {
  Blog = 'Blog',
  Site = 'Site',
}

export type ThemeType = keyof typeof ThemeEnum;
